namespace GeniuzPOS.ReportMasterData {
    export interface Report_1401Form {
    }

    export class Report_1401Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1401';
    }
}
